<template>
  <b-card>
    <div v-if="isExpanded==false" class="text-center">
      <b-button  @click="isExpanded = true;">Request a Deposit</b-button>
    </div>
    <div v-else>
      <b-form-group label="Deposit Payment">
        <b-form-radio-group
          v-model="fullAmount"
          class="mt-2"
          name="deposit-amount"
          :options="options"
        />
        <div class="deposit-amount mt-4">
          <span>Deposit Amount:</span>
          <currency-input
            v-if="!fullAmount"
            name="Deposit Amount"
            :size="12"
            :amount.sync="depositAmount"
            :fieldState="fieldState.amount"
          />
          <span v-else class="ml-3">{{ getVendor.local_currency }}{{ prettyBalance }}</span>
        </div>
      </b-form-group>
      <div class="copy-link">
        <b-form-input readonly :value="linkUrl"></b-form-input>
        <b-btn
          v-clipboard:copy="linkUrl"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >
          <i class="fi fi-clipboard-pencil" />
        </b-btn>
      </div>
      <br><br>
      <b-button @click="isExpanded = false;"> Done </b-button>
    </div>
  </b-card>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import API from '../../api';

  export default {
    name: 'CollectDeposit',
    components: {
      CurrencyInput: () => import('@/components/widgets/CurrencyInput')
    },
    props: {
      balance: {
        required: true,
        default: 0
      },
      tabId: {
        required: true
      }
    },

    data() {
      return {
        isExpanded: false,
        fullAmount: true,
        options: [
          {
            text: 'Full Amount',
            value: true
          },
          {
            text: 'Partial Deposit',
            value: false
          }
        ],
        depositAmount: 0,
        fieldState: {
          amount: true
        }
      }
    },

    methods: {
      onCopy: function (e) {
        this.infoNotification('Deposit link copied to clipboard.')
      },

      onError: function (e) {
        this.errorNotification('Failed to copy link, please try again or copy manually.')
      }
    },

    computed: {
      ...mapGetters([
        'getVendor'
      ]),

      ...mapState({
        vendorId: state => state.vendor.vendor.id
      }),

      decidedAmount() {
        return this.fullAmount
          ? parseInt(this.balance * 100)
          : parseInt(this.depositAmount * 100)
      },

      linkUrl() {
        return `${API.BASE_DOMAIN}${API.DEPOSIT}/vendor/${this.vendorId}/tab/${this.tabId}/amount/${this.decidedAmount}`
      },

      prettyBalance() {
        return parseFloat(this.balance).toFixed(2)
      }
    }
  }
</script>

<style lang="scss">
  .deposit-amount {
    display: flex;
    justify-content: center;
    align-items: center;

    .currency-input {
      max-width: 250px
    }
  }

  .copy-link {
    display: flex;
  }
</style>
